import { Unit } from '@interfaces/Material'
import { LP_UNIT_TYPE } from '@utils/constants/learningPath'

export const determinLCSZero = (unitId: string, units: Unit[]) => {
  const unit = (units || []).find(({ Id }) => Number(unitId) === Number(Id))
  return unit?.Order === 1 && unit?.UnitType === LP_UNIT_TYPE.COACHING
}

type LpidInput = string | null | undefined

const invalidLpidValues = new Set(['', 'null', 'undefined'])

export const getValidLpids = (lpids: LpidInput | LpidInput[]) => {
  const values = Array.isArray(lpids) ? lpids : [lpids]

  const normalizedLpids = values
    .flatMap((lpid) => String(lpid ?? '').split('|'))
    .map((lpid) => lpid.trim())
    .filter((lpid) => !invalidLpidValues.has(lpid.toLowerCase()))

  return [...new Set(normalizedLpids)]
}

export const joinValidLpids = (lpids: LpidInput | LpidInput[]) => getValidLpids(lpids).join('|')
